import { isString as n, isNumber as t } from "./types.js";
function s(r, i = "px") {
  if (!r)
    return "";
  if (n(r))
    return r;
  if (t(r))
    return `${r}${i}`;
  console.warn("utils/style", "binding value must be a string or number");
}
export {
  s as addUnit
};
